/**
 * PlayerPageHeaderSkeletonContainer - Container for loading skeleton
 *
 * Handles theme detection and passes to skeleton view.
 * @remarks This is a Container component - handles logic
 */

import { useTheme } from "@/providers/ThemeProvider";

import PlayerPageHeaderSkeletonView from "./PlayerPageHeaderSkeletonView";

/**
 * PlayerPageHeaderSkeletonContainer provides theme context to skeleton view
 * @returns PlayerPageHeaderSkeletonView with theme props
 */
const PlayerPageHeaderSkeletonContainer = () => {
  // 1. VARIABLES & DERIVED STATE
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  // 2. SIDE EFFECTS (none)

  // 3. RETURN
  return <PlayerPageHeaderSkeletonView isDark={isDark} />;
};

PlayerPageHeaderSkeletonContainer.displayName =
  "PlayerPageHeaderSkeletonContainer";

export default PlayerPageHeaderSkeletonContainer;
